<template>
  <div
    class="FilterBar">
    <h2
      v-if="title"
      class="relative font-normal font-18 pb-3"
      key="TFB-title">
      {{ title }}
      <BaseLoader
        v-if="isLoading"
        class="FilterBar_loader"
        key="TFB-loader"
      />
    </h2>

    <FilterGroup
      class="FilterBar_FilterGroup"
      v-for="filterGroup in computedFilters"
      :key="filterGroup.key"
      :group-key="filterGroup.key"
      :label="filterGroup.label"
      :filters="filterGroup.filters"
      :show-count="filterGroup.showCount"
      :search-bar="filterGroup.searchBar"
      :search-placeholder="filterGroup.searchPlaceholder"
      :is-loading="isLoading"
      :value="value"
      @input="handleFilterInput"
      @clear-group="$emit('clear-group', filterGroup.key)"
    />

  </div>
</template>

<script>
import FilterGroup from '@/components/FilterGroup.vue';
import BaseLoader from '@/components/BaseLoader.vue';

export default {
  name: 'FilterBar',

  components: {
    FilterGroup,
    BaseLoader,
  },

  props: {
    title:     { type: String,  default: null },
    value:     { type: Array,   required: true },
    filters:   { type: Array,   default: () => [] },
    isLoading: { type: Boolean, default: false },
  },

  computed: {
    computedFilters() {
      if (this.isLoading) {
        return [1, 2, 3].map((f) => ({
          key: `placeholder${f}`,
          filters: [],
        }));
      }
      return this.filters;
    },
  },

  methods: {
    handleFilterInput(groupKey, filter) {
      this.$emit('filter-input', groupKey, filter);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.FilterBar {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 250px;
  padding: 24px;
  background-color: #F6F6F6;
  border-right: $border;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
}

.FilterBar_loader {
  position: absolute;
  top: -2px;
  right: 0;
}

.FilterBar_FilterGroup {
  padding-bottom: 16px;
  margin-bottom: 20px;
  &:not(:last-child) {
    border-bottom: $border;
  }
}
</style>
